import { useIntl } from 'react-intl';
const useMultiLanguageFileDownloadLog = () => {
  const intl = useIntl();
  const FILE_DOWNLOAD_LOG_LIST_TITLE = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.title',
  });
  const FILE_DOWNLOAD_LOG_TABLE_ID = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.table.id',
  });
  const FILE_DOWNLOAD_LOG_TABLE_COUNT = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.table.count',
  });
  const FILE_DOWNLOAD_LOG_TABLE_ACCOUNT_EMAIL = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.table.account.email',
  });
  const FILE_DOWNLOAD_LOG_TABLE_PARTNER_NAME = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.table.partner.name',
  });
  const FILE_DOWNLOAD_LOG_TABLE_FILE_DOWNLOAD_PRODUCT_NAME = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.table.fileDownload.productName',
  });
  const FILE_DOWNLOAD_LOG_TABLE_FILE_DOWNLOAD_DETAIL_TITLE = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.table.fileDownload.detailTitle',
  });
  const FILE_DOWNLOAD_LOG_TABLE_FILE_DOWNLOAD_URL = intl.formatMessage({
    id: 'authentication.fileDownloadLogList.table.fileDownload.url',
  });
  return {
    FILE_DOWNLOAD_LOG_LIST_TITLE,
    FILE_DOWNLOAD_LOG_TABLE_ACCOUNT_EMAIL,
    FILE_DOWNLOAD_LOG_TABLE_PARTNER_NAME,
    FILE_DOWNLOAD_LOG_TABLE_ID,
    FILE_DOWNLOAD_LOG_TABLE_COUNT,
    FILE_DOWNLOAD_LOG_TABLE_FILE_DOWNLOAD_PRODUCT_NAME,
    FILE_DOWNLOAD_LOG_TABLE_FILE_DOWNLOAD_DETAIL_TITLE,
    FILE_DOWNLOAD_LOG_TABLE_FILE_DOWNLOAD_URL,
  };
};
export default useMultiLanguageFileDownloadLog;
